<script>
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import {
  required,
  minLength,
  sameAs,
 
} from 'vuelidate/lib/validators'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: 'Cuenta Usuario',
    meta: [{ name: 'description', content: appConfig.description }],
  },
   props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {  
      exitoso:null ,  
      title: 'Cuenta',
      data : null,
      procesando: false,
      form:{
        repPassword:null,
        newPassword:null,
        currenPassword:null,
        idUser: this.user.idUser

      },
      submitted: false, 
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Cuenta',
          active: true,
        },
      ]
    }
  },
  computed:{
  
  },
  mounted(){

   
  },
   methods:{

     actualizarPassword(bvModalEvent){
       bvModalEvent.preventDefault();
       this.submitted = true
      if(!this.$v.$invalid){
        this.procesando = true;
        return axios
            .post(appConfig.recursosApi.actualizarPassword,this.form)
            .then((response) => {
              this.$bvModal.hide("modal-actualizar-password");
              this.makeToast("success","Se ha actualizado la contraseña", "Actualizar contraseña");
              this.procesando = false;
            }).catch((error)=>  {
              this.$bvModal.hide("modal-actualizar-password");
              this.makeToast("danger","No se ha podido actualizar la contraseña "  + error.response.data.errores[0] , "Actualizar contraseña");
                this.procesando = false;
            });

      }
       this.$v.$touch()
     },
     makeToast(variant = null,message = null, titleToast = null) {
        this.$bvToast.toast(message, {
          title: titleToast,
          variant: variant,
          solid: true
        })
      },
    
     },
   validations:  {
        form: {
    
      newPassword: { required, minLength: minLength(6) },
      rePassword: { required, sameAsPassword: sameAs('newPassword') },
      currentPassword: { required },
    },

   

   }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
       <div class="col-lg-4 col-xl-4 "></div>
     <div class="col-lg-4 col-xl-4 ">
        <div class="card-box text-center">
        
          <h4 class="mb-0">{{ user.name }}</h4>
          <p class="text-muted">{{ user.user }}</p>
          <b-button v-b-modal.modal-actualizar-password variant="btn btn-success btn-xs waves-effect mb-2 waves-light">Actualizar contraseña</b-button>
          <b-modal
          
            id="modal-actualizar-password" 
            title="Actualizar Contraseña" 
            data-animation="blur"
            ok-title = "Actualizar"
            cancel-title = "Cancelar"

            title-class="font-18"
            @ok="actualizarPassword"
            >
              <p
            class="text-muted font-14 m-b-20"
          >Ingrese la nueva contraseña.</p>

          <form >
            <div class="form-group">
              <label for="name">
                Contraseña Actual
                <span class="text-danger">*</span>
              </label>
              <input
                id="currentPassword"
                v-model="form.currentPassword"
                name="currenPassword"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.currentPassword.$error }"
                type="password"
                placeholder=""
              />
              <div
                v-if="submitted && !$v.form.currentPassword.required"
                class="invalid-feedback"
              >Ingrese la contraseña actual.</div>
            </div>
            <div class="form-group">
              <label for="name">
                Nueva Contraseña
                <span class="text-danger">*</span>
              </label>
              <input
                id="newPassword"
                v-model="form.newPassword"
                name="username"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.newPassword.$error }"
                type="password"
                placeholder=""
              />
              <div
                v-if="submitted && !$v.form.newPassword.required"
                class="invalid-feedback"
              >Ingresa la contraseña nueva.</div>
            </div>
            <div class="form-group">
              <label>
                Repite la Contraseña
                <span class="text-danger">*</span>
              </label>
              <input
              id= "rePassword"
                v-model="form.rePassword"
                type="password"
                name="direccion"
                class="form-control"
                :class="{ 'is-invalid': submitted && $v.form.rePassword.$error }"
                placeholder=""
              />
              <div v-if="submitted && $v.form.rePassword.$error" class="invalid-feedback">
                <span v-if="!$v.form.rePassword.required">Repita la contraseña</span>
                <span
                  v-else-if="!$v.form.rePassword.sameAsPassword"
                >La contraseña deben ser iguales.</span>
              </div>
            </div>
       
          </form>
          <div slot="modal-ok">
            <b-spinner v-show="procesando" small></b-spinner> Actualizar
                    
          </div>

            </b-modal>
          

          <div class="text-left mt-3">
            
            <p class="text-muted mb-2 font-13">
              <strong>Nombre: </strong>
              <span class="ml-2">
                {{ user.name }}
              </span>
            </p>

            <p class="text-muted mb-2 font-13">
              <strong>Teléfono:</strong>
              <span class="ml-2">
                {{ user.telefono }}
              </span>
            </p>

            <p class="text-muted mb-2 font-13">
              <strong>Email :</strong>
              <span class="ml-2">{{ user.email }}</span>
            </p>

            <p class="text-muted mb-1 font-13">
              <strong>Organismo :</strong>
              <span class="ml-2">{{ user.organismo }}</span>
            </p>
            <p class="text-muted mb-1 font-13">
              <strong>Rol :</strong>
              <span class="ml-2">{{ user.rol }}</span>
            </p>
          </div>

        </div>
        <!-- end card-box -->

 
      </div>
    </div>
  </Layout>
</template>